import { render, staticRenderFns } from "./NsProductRecsCarousel.vue?vue&type=template&id=28072019&"
import script from "./NsProductRecsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsProductRecsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsProductRecsCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports